import { navbarMobileInfrastructureStyle } from "./navbarVisualOwnership";

export function resolveNavbarMobileStyle({ navigation = {} } = {}) {
  // Layout/assets only. Visual colors live in explicit owners consumed by each component.
  return navbarMobileInfrastructureStyle(navigation);
}
